module.exports = __webpack_public_path__ + "img/report_black_24dp.65a15b24.svg";